import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { getApiErrorMessage } from "../getApiErrorMessage";

export interface EventVenueResponse {
  id: number;
  name: string;
  address: string;
  locationId?: number | null;
  locationName?: string | null;
  type: "RESTAURANT" | "AFTER_PARTY";
  eventCount: number;
  reviewCount: number;
  avgScore: number | null;
}

export const useGetEventVenues = () => {
  return useQuery<EventVenueResponse[], Error>({
    queryKey: ["event-venues"],
    queryFn: async () => {
      const response = await apiFetch("api/event/venues");
      if (!response.ok) {
        throw new Error(await getApiErrorMessage(response));
      }
      return response.json();
    },
  });
};
